import React from 'react'
import PrivacyPolicy from '../privacy-policy'

const PrivacyPolicySv = () => {
    return <PrivacyPolicy languageCode="sv" />
}

export default PrivacyPolicySv
